// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Twitter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Twitter = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Twitter = _exports.Twitter = function Twitter(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.616 6.65794C16.6244 6.79961 16.6243 6.94961 16.6243 7.09961C16.6243 11.5496 13.191 16.6746 6.90768 16.6746C4.97434 16.6746 3.17435 16.1246 1.66602 15.1663C1.94102 15.1996 2.20769 15.2079 2.49102 15.2079C4.09102 15.2079 5.55768 14.6746 6.73268 13.7746C5.23268 13.7413 3.97435 12.7746 3.54102 11.4413C3.74935 11.4746 3.96602 11.4913 4.18269 11.4913C4.49102 11.4913 4.79935 11.4496 5.08269 11.3746C3.51602 11.0579 2.34101 9.70794 2.34101 8.07461V8.03294C2.79935 8.28294 3.32435 8.44127 3.88269 8.45793C2.96602 7.8496 2.35768 6.8246 2.35768 5.65793C2.35768 5.03293 2.52435 4.45794 2.82435 3.95794C4.50768 5.99961 7.03268 7.33294 9.86601 7.48294C9.81601 7.23294 9.78269 6.9746 9.78269 6.71627C9.78269 4.85794 11.3077 3.34961 13.1993 3.34961C14.1827 3.34961 15.0744 3.75793 15.691 4.40793C16.466 4.26627 17.1993 3.98295 17.8577 3.59961C17.6077 4.38295 17.066 5.04127 16.3577 5.4496C17.041 5.3746 17.7077 5.19127 18.3244 4.93294C17.8577 5.5996 17.2743 6.19127 16.6077 6.6746L16.616 6.65794Z",
      fill: "currentColor"
    }));
  };
});
